import { GetProgressionLevelName } from 'functions/textUtils'
import { equipmentOptions } from 'functions/equipmentUtils'

export default function ExerciseProgressionObject({
    exercises,
    programTableColumn = null,
    exercise,
}) {

    const databaseExercise = exercises.find((databaseExercise) => databaseExercise.id === exercise.id)

    const GetProgressionLevelColor = (progressionLevel) => {

        var style = ''

        if (progressionLevel === 0) style += 'bg-orange-100 '
        else if (progressionLevel === 1) style += 'bg-orange-200 '
        else if (progressionLevel === 2) style += 'bg-orange-300 '
        else if (progressionLevel === 3) style += 'bg-orange-400 '
        else if (progressionLevel === 4) style += 'bg-orange-500 '

        return style

    }

    return (
        <div className='rounded-xl overflow-hidden'>

            {programTableColumn !== null && (
                <div className='h-24 flex flex-col justify-center items-center bg-gray-100 space-y-0.5'>
                    <div className='font-semibold text-xs'>Week {programTableColumn.programWeekIndex + 1}</div>
                    <div className='font-semibold text-xs'>{programTableColumn.weekOfTheYearKey}</div>
                    <div className='text-xs'>{programTableColumn.volumeData.programWeekKey}</div>

                    {programTableColumn.volumeData.taperData?.progressionLevelRegression > 0 &&
                        <div className='text-xs font-bold'>Minus {programTableColumn.volumeData.taperData.progressionLevelRegression} Progressions</div>
                    }
                </div>
            )}

            <div 
                className={`
                    ${GetProgressionLevelColor(parseInt(exercise.progressionLevel))}
                    w-40 px-4 h-32 flex flex-col justify-center items-center text-center space-y-1
                `}
            >
                <div className='italic text-xxs'>
                    ({exercise.progressionLevel}) {GetProgressionLevelName(exercise.progressionLevel)} 
                    {' '}
                    {exercise.progressionLevelScoreSubLevelUpperBound && (
                        <span className='text-xxs font-bold'>
                            {exercise.progressionLevelScoreSubLevelUpperBound}
                        </span>
                    )}
                </div>

                <div className='font-semibold text-xs'>
                    {/* ({exercise.id}) */}
                    {exercise.name}
                </div>

                {exercise.durationWeeks && 
                    <div className='text-xs'>
                        {exercise.durationWeeks} weeks
                    </div>
                }

                {exercise.id !== -1 && databaseExercise?.equipment.length > 0 &&
                    <div className="flex px-2 gap-x-2">
                        {databaseExercise.equipment.split(',').map((text, index) => (
                            <img 
                                key={index} 
                                src={equipmentOptions.find((option) => option.key === text).imageURL} 
                                alt="Equipment Icon" 
                                className="h-6" 
                            />
                        ))}
                    </div>
                } 
            </div>
        </div>
    )
}